<mat-toolbar class="p-0 mat-elevation-z1">

    <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">

        <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">

            <button mat-icon-button class="navbar-toggle-button"
                    *ngIf="!hiddenNavbar && !rightNavbar" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>

            <div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>

            <div fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNavbar">
                <div class="logo ml-16">
                    <img class="logo-icon" src="assets/images/logos/fuse.svg">
                </div>
            </div>

            <div class="px-8 px-md-16">

                <!--<fuse-shortcuts [navigation]="navigation"></fuse-shortcuts>-->

            </div>

        </div>

        <div *ngIf="(selectedBranch && branches)" class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">

            <button mat-button [matMenuTriggerFor]="branchMenu" class="user-button">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <i class="far fa-address-book"></i>&nbsp;
                    <span class="username mr-12" fxHide fxShow.gt-sm>{{selectedBranch.name}}</span>
                    <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
                </div>
            </button>

            <mat-menu #branchMenu="matMenu" [overlapTrigger]="false">

                <button *ngFor="let branch of branches" mat-menu-item (click)="setBranch(branch)">
                    <i class="far fa-address-card"></i>&nbsp;
                    <span>{{branch.name}}</span>
                </button>

            </mat-menu>

            <button mat-button [matMenuTriggerFor]="userMenu" class="user-button">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <i class="fas fa-user-circle fa-fw"></i>&nbsp;
                    <span class="username mr-12" fxHide fxShow.gt-sm>{{profile?.email}}</span>
                    <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
                </div>
            </button>

            <mat-menu #userMenu="matMenu" [overlapTrigger]="false">

                <button mat-menu-item class="" (click)="logout()">
                    <mat-icon>exit_to_app</mat-icon>
                    <span>Odhlásit</span>
                </button>

            </mat-menu>


        </div>

    </div>

</mat-toolbar>
